import { Link, Outlet } from "react-router-dom";
import Breadcrumbs from "../admin/Breadcrumbs";

function AdminLayout() {
  return (
    <div className="admin-layout">
      <header className="admin-header">
        <h1>Fond du Lac County News</h1>
        <h2>🔐 Admin Panel</h2>

        <Breadcrumbs />

        <div className="admin-nav">
          <Link to="/admin">Dashboard</Link>
          <Link to="/">Exit Admin</Link>
        </div>
      </header>

      <main className="admin-content">
        <Outlet />
      </main>
    </div>
  );
}

export default AdminLayout;
